export class Address {
  // current address
  sAddrStreet: string;
  sAddrCity: string;
  sAddrState: string;
  sAddrZip: string;
  sAddrCountry: string;
  sAddrType: number;
  sSearch: string;
  sResidencyType: string;
  sResidencyDuration: number;
  sRemarks = "";
}
